module.exports = __webpack_public_path__ + "static/tennis-ab8c03849de42d4469de26ab6abd5b8f.jpg";